(($)=>{
    "use strict";


    const svgEl =  document.getElementById('guide-svg-animated');
    if(!svgEl){
        return;
    }

    const lines= {
        top: {
            line: svgEl.querySelector('#top-line'),
            circle: svgEl.querySelector('#top-circle')
        },
        left: {
            line: svgEl.querySelector('#left-line'),
            circle: svgEl.querySelector('#left-circle')
        },
        bottom: {
            line: svgEl.querySelector('#bottom-line'),
            circle: svgEl.querySelector('#bottom-circle')
        },

    };



    function animateDisappear(){

        lines.top.line.style.opacity = 0;
        lines.top.circle.style.opacity = 0;

        lines.left.line.style.opacity = 0;
        lines.left.circle.style.opacity = 0;

        lines.bottom.line.style.opacity = 0;
        lines.bottom.circle.style.opacity = 0;

    }

    function animateAppear(){

        const topLength = lines.top.line.getTotalLength();
        lines.top.line.style.strokeDasharray = topLength;
        lines.top.line.style.strokeDashoffset = -1 *  topLength;
        lines.top.line.style.opacity = 1;
        lines.top.circle.style.opacity = 0;
        $(lines.top.line).animate({strokeDashoffset: 0}, 500, function(){
            $(lines.top.circle).animate({opacity: 1}, 200);
        });

        const bottomLength = lines.bottom.line.getTotalLength();
        lines.bottom.line.style.strokeDasharray = bottomLength;
        lines.bottom.line.style.strokeDashoffset = bottomLength;
        lines.bottom.line.style.opacity = 1;
        lines.bottom.circle.style.opacity = 0;
        $(lines.bottom.line).animate({strokeDashoffset: 0}, 800, function(){
            $(lines.bottom.circle).animate({opacity: 1}, 200);
        });


        const leftLength = lines.left.line.getTotalLength();
        lines.left.line.style.strokeDasharray = leftLength;
        lines.left.line.style.strokeDashoffset = -1 *  leftLength;
        lines.left.line.style.opacity = 1;
        lines.left.circle.style.opacity = 0;
        $(lines.left.line).animate({strokeDashoffset: 0}, 1000, function(){
            $(lines.left.circle).animate({opacity: 1}, 200);
        });

    }

    // enable animations in case we have IntersectionObserver
    if(window['IntersectionObserver']){
        animateDisappear();
        // then set up observer.
        const observer = new IntersectionObserver(function(entries){

            entries.forEach((entry)=>{

                if(entry.intersectionRatio > 0.5){
                    animateAppear();
                }else{
                    animateDisappear();
                }

            });

        }, {threshold: [0, 1] });


        observer.observe(svgEl);
    }

})(jQuery)